<template lang="pug">
section.mg-section.mg-game(:class="{'mg-game--active' : isUserInProject && isUserJoined}")
  NoAuth.mg-noauth(v-if="!isUserInProject")

  .mg-game__inner(v-else, :class="{'mg-game__inner--start' : !isUserJoined}")

    button.button.button-large-x15(v-if="!isUserJoined" @click="joinActivity")
      span {{ $t('game.start') }}

    template(v-else)
      .mg-game__header
        GameDeck(:inProgress="in_progress" @startProgress="startProgress")
        GameMoney
        GameSuperprize

      .mg-game__list
        GameRow(
          v-for="(row, index) in getPrizesList.rows",
          :key="index",
          :rowNumber="index + 1",
          :prize="row"
          :openedCards="getCardsList.rows[index]"
        )

      .mg-game__footer(v-if="!isActionEnd")
        button.button.button-medium(@click="showTopUp")
          span {{ $t('top_up.button') }}

        GameTimer

      GameFinish(v-else)

    Popup(@stopProgress="stopProgress")

</template>

<script>
import "@/assets/game/styles/game.styl";

import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapState: mapMinigamesState, mapGetters: mapMinigamesGetters } =
  createNamespacedHelpers(mg_global);
const { mapGetters } = createNamespacedHelpers("global");

import NoAuth from "@chronos/frontend-base/src/components/noauth/NoAuth";
import GameTimer from "./blocks/GameTimer";
import GameRow from "./blocks/GameRow";
import GameDeck from "./blocks/GameDeck";
import GameMoney from "./blocks/GameMoney";
import GameSuperprize from "./blocks/GameSuperprize";
import GameFinish from "./blocks/GameFinish";
import Popup from "./../popup/Popup";

export default {
  name: "Game",

  components: {
    NoAuth,
    GameTimer,
    GameRow,
    GameDeck,
    GameMoney,
    GameSuperprize,
    GameFinish,
    Popup,
  },

  data() {
    return {
      in_progress: false,
    };
  },

  computed: {
    ...mapMinigamesState(["current_time", "ends_at"]),
    ...mapMinigamesGetters(["isUserJoined", "getPrizesList", "getCardsList", "getMaxShardsCount"]),
    ...mapGetters(["isUserInProject"]),

    isActionEnd() {
      return this.current_time > this.ends_at;
    },

    isSuperPrizeReady() {
      return this.getCardsList.superprize === this.getMaxShardsCount;
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.isSuperprizeReady) {
        this.showSuperPrizePopup();
      }
    });
  },

  methods: {
    joinActivity() {
      this.$store.dispatch(`${mg_global}/joinActivity`);
    },

    showTopUp() {
      this.$emit("showTopUp");
    },

    startProgress() {
      this.in_progress = true;
    },

    stopProgress() {
      this.in_progress = false;
    },

    showSuperPrizePopup() {
      this.$store.commit(`${mg_global}/setCurrentReward`, this.getPrizesList.superprize);
      this.$store.commit(`${mg_global}/setPopup`, "reward_superprize");
    },
  },
};
</script>
